import getRuleError from "../utils/getRuleError";
import getRuleValue from "../utils/getRuleValue";
import {translate} from "../../../../i18n";
import {getAbsoluteSeconds} from "../../../../utils/time-hms/index";
import {timeIsNull} from "../../../../utils/time-hms/index";

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired() || checkIsClosedRange() || checkAreInSameDay();
}

function checkRequired() {
    const {required} = $rules;
    const {hasSeconds} = $options;

    const ruleValue = getRuleValue(required, $allValues);
    const ruleError = getRuleError(required, $allValues, translate('Required'));

    if (ruleValue === true) {
        if (timeIsNull($value[0], hasSeconds) && timeIsNull($value[1], hasSeconds)) {
            return ruleError;
        }
    }

    if (ruleValue instanceof Array) {
        if (ruleValue[0] === true && timeIsNull($value[0], hasSeconds)) {
            return ruleError;
        }

        if (ruleValue[1] === true && timeIsNull($value[1], hasSeconds)) {
            return ruleError;
        }
    }

    return null;
}

function checkIsClosedRange() {
    const {isClosedRange} = $rules;
    const {hasSeconds} = $options;

    const ruleValue = getRuleValue(isClosedRange, $allValues);

    if (ruleValue === true) {
        const startNull = timeIsNull($value[0], hasSeconds);
        const endNull = timeIsNull($value[1], hasSeconds);

        if (startNull && !endNull || !startNull && endNull) {
            const defaultRuleError = startNull
                ? translate('Start time cannot be blank while end time is filled')
                : translate('End time cannot be blank while start time is filled');

            return getRuleError(isClosedRange, $allValues, defaultRuleError);
        }

    }

    return null;
}


function checkAreInSameDay() {
    if (timeIsNull($value[0]) || timeIsNull($value[1])) {
        return null;
    }

    const {areInSameDay} = $rules;
    const {hasSeconds} = $options;

    const ruleValue = getRuleValue(areInSameDay, $allValues);

    if (ruleValue !== true) {
        return null;
    }

    if (getAbsoluteSeconds($value[0], hasSeconds) <= getAbsoluteSeconds($value[1], hasSeconds)) {
        return null;
    }

    return getRuleError(areInSameDay, $allValues, translate('In the same day, start time cannot be greater than end time'));
}

